import { Component, OnDestroy, effect, inject, input, signal } from '@angular/core';
import { SubSink } from 'subsink';
import { UserModel } from '../../../core/models/user/user.model';
import { UserService } from '../../../pages/user/services/user.service';

@Component({
  selector: 'app-shive-avatar',
  templateUrl: './shive-avatar.component.html',
  styleUrls: ['./shive-avatar.component.scss'],
  standalone: false,
})
export class ShiveAvatarComponent implements OnDestroy {
  user = input.required<UserModel | null>();
  width = input(36);
  height = input(36);

  avatarUrl = signal<string | null>(null);
  initials = signal<string | null>(null);

  private readonly userService = inject(UserService);
  private readonly subs = new SubSink();

  private currentObjectUrl: string | null = null;

  constructor() {
    effect(() => {
      const u = this.user();
      if (!u?.id) {
        return;
      }

      // reset subscription when user changes
      this.subs.unsubscribe();

      this.subs.add(
        this.userService.getUserAvatarThumb$(u.id).subscribe((avatar) => {
          // cleanup previous object URL WITHOUT reading avatarUrl()
          if (this.currentObjectUrl) {
            URL.revokeObjectURL(this.currentObjectUrl);
            this.currentObjectUrl = null;
          }

          if (avatar?.file.name) {
            const url = URL.createObjectURL(avatar.file);
            this.currentObjectUrl = url;

            this.avatarUrl.set(url);
            this.initials.set(null);
          } else {
            this.avatarUrl.set(null);
            this.initials.set(this.userService.getUserInitials(u));
          }
        }),
      );
    });
  }

  ngOnDestroy(): void {
    if (this.currentObjectUrl) URL.revokeObjectURL(this.currentObjectUrl);
    this.subs.unsubscribe();
  }
}
